import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { Partner } from '../EventTypes'
import { PlayerState } from '../models/player'
import { IRootStore } from '../models/root'
import { ISequenceItem } from '../models/script'
import './Card.scss'
import CardProgress from './CardProgress'
import { InterpolatedStyles } from './CardStack'
import Icon, { IconName } from './Icon'

const keyword = '___'

const markSmalls = (text: string) => {
  const parts = text.split(new RegExp(`(${keyword})`, 'gi'))
  const output: Array<string | JSX.Element> = []

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].toLowerCase() === keyword.toLowerCase()) {
      // output.push(<small key={i}>{parts[i + 1]}</small>)
      i += 2
    } else {
      output.push(parts[i])
    }
  }

  return output
}

interface ICardProps {
  visibleIndex: number
  interpolatedStyles: InterpolatedStyles
  card: ISequenceItem
  images: Map<string, string>
}

interface InjectedProps extends ICardProps {
  store: IRootStore
}

@inject('store')
@observer
class Card extends React.Component<ICardProps> {
  get injected() {
    return this.props as InjectedProps
  }

  public render() {
    const { interpolatedStyles } = this.props

    return (
      <div
        className={'card'}
        style={{
          opacity: interpolatedStyles.opacity,
          transform: `translate3d(${interpolatedStyles.translateX}px, ${
            interpolatedStyles.translateY
          }px, 0) rotate(${interpolatedStyles.rotation}deg)`,
          // Ensure the order of cards is top -> bottom
        }}
      >
        {this.renderCardContent()}
      </div>
    )
  }

  private renderCardContent() {
    const { store } = this.injected
    const { visibleIndex, card, images } = this.props

    let content = null
    if (card.source) {
      content = (
        <blockquote className="card__quote">
          <p> &ldquo;{card.title}&rdquo;</p>
          <cite>— {card.source}</cite>
        </blockquote>
      )
    } else if (card.image) {
      const imageURL = images.get(card.image)

      content = (
        <>
          <img className="card__image" src={imageURL} />
          <h1 className="card__title small_title card__title--center">
            {markSmalls(card.title)}
          </h1>
        </>
      )
    } else {
      content = (
        <h1 className="card__title small_title">{markSmalls(card.title)}</h1>
      )
    }

    return (
      <>
        {content}

        <div className={`card__partners` + ` card__partners--${card.partner}`}>
          <div
            className="card__partner card__partner--one"
            style={{
              backgroundColor: store.player.playerOneColor,
            }}
          >
            <div className="card__partner__avatar" />
            <span className="card__partner__number">1</span>
          </div>
          <div
            className="card__partner card__partner--two"
            style={{
              backgroundColor: store.player.playerTwoColor,
            }}
          >
            <div className="card__partner__avatar" />
            <span className="card__partner__number">2</span>
          </div>
        </div>

        <div className="card__bottom">
          <CardProgress shouldUpdate={visibleIndex === 0} />

          <button
            onClick={this.handlePausePlayClick}
            className={
              'card__pauseplay' +
              ' ' +
              `card__pauseplay--${
                store.player.state === PlayerState.playing
                  ? 'playing'
                  : 'paused'
              }`
            }
          >
            {store.player.state === PlayerState.playing ? (
              <Icon
                className="card__pauseplay__icon"
                name={IconName.pause}
                // color={accentColor}
              />
            ) : (
              <Icon
                className="card__pauseplay__icon"
                name={IconName.play}
                // color={accentColor}
              />
            )}
          </button>
        </div>
      </>
    )
  }

  private handlePausePlayClick = () => {
    const { store } = this.injected

    store.player.setPlayerState(
      store.player.state === PlayerState.playing
        ? PlayerState.paused
        : PlayerState.playing
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.tsx